/* src/app/components/about-component/about-component.css */
/*# sourceMappingURL=about-component.css.map */
